import { createSlice } from '@reduxjs/toolkit';
import { COLUMN_ACCESSORS } from '../../../../constants/table';

const initialState = {
  accessor: COLUMN_ACCESSORS.SEQUENCE_NUMBER,
  isAscending: true,
};

const stopListOrderSlice = createSlice({
  name: 'stopListOrder',
  initialState,
  reducers: {
    setOrder(state, action) {
      if (state.accessor === action.payload) {
        state.isAscending = !state.isAscending;
      } else {
        state.accessor = action.payload;
        state.isAscending = true;
      }
    },
    setDefaultOrder() {
      return initialState;
    },
  },
});

export const { setOrder, setDefaultOrder } = stopListOrderSlice.actions;

export default stopListOrderSlice.reducer;
